export default __webpack_public_path__ + "img/imprimante.c6eb60db.svg";